import type { GlobalToken } from 'antd/es/theme';
import { purple, purpleDark } from '@ant-design/colors';

/** Background, border, text and icon colours for a role badge. */
export interface RoleTokenStyles {
  bg: string;
  border: string;
  text: string;
  icon: string;
}

/**
 * Maps a role's preset colour name (as used on its Tag) to badge colours from theme tokens.
 * Purple has no semantic token, so it uses the @ant-design/colors presets for the current theme.
 */
export function getRoleTokenStyles(color: string | undefined, token: GlobalToken): RoleTokenStyles {
  switch (color) {
    case 'blue':
      return { bg: token.colorPrimaryBg, border: token.colorPrimaryBorder, text: token.colorPrimary, icon: token.colorPrimary };
    case 'green':
      return { bg: token.colorSuccessBg, border: token.colorSuccessBorder, text: token.colorSuccess, icon: token.colorSuccess };
    case 'purple': {
      const isDark = document.documentElement.getAttribute('data-theme') === 'dark';
      const palette = isDark ? purpleDark : purple;
      return { bg: palette[0], border: palette[2], text: palette[6], icon: palette[5] };
    }
    default:
      return { bg: token.colorFillQuaternary, border: token.colorBorder, text: token.colorText, icon: token.colorTextSecondary };
  }
}
